import React from 'react';

const SwitchOn = () => {
  return (
    <svg
      width="46"
      height="24"
      viewBox="0 0 46 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="46" height="24" rx="12" fill="#5C77FF" />
      <circle cx="34" cy="12" r="11" fill="#EDEDED" />
    </svg>
  );
};

export default SwitchOn;
